import React, { useContext } from "react";
import { RecordsManagementContext } from "../StatesMangement/InitialiseContext";

const inputStyle = {
  width: "100%",
  textAlign: "center",
  backgroundColor: "#e9ecef",
  border: "1px solid #ced4da",
  borderRadius: "4px",
  padding: "4px 8px",
  height: "30px",
  fontSize: "12px"
};

const dateInputStyle = {
  ...inputStyle,
  minWidth: "98px",
  fontSize: "11px",
  padding: "4px 6px"
};

const headerCellStyle = {
  whiteSpace: "nowrap",
  fontSize: "12px",
  fontWeight: 600,
  textAlign: "center",
  verticalAlign: "middle",
  borderTop: 0
};

const bodyCellStyle = {
  fontSize: "12px",
  textAlign: "center",
  verticalAlign: "middle"
};

export default () => {
  const IV2_PageDetails = useContext(RecordsManagementContext).IV2_PageDetails;
  const jobTimes = IV2_PageDetails.TimeRecord.JobTimes || [];

    return (
        <div className='card'>
            <div className='card-header bg-secondary text-center'>TIME RECORD</div>
      <div className='card-body p-2'>
        <div className='table-responsive'>
          <table className='table table-sm mb-0'>
            <colgroup>
              <col style={{ width: "12%" }} />
              <col style={{ width: "14%" }} />
              <col style={{ width: "18%" }} />
              <col style={{ width: "14%" }} />
              <col style={{ width: "18%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "14%" }} />
            </colgroup>
            <thead>
              <tr>
                <th style={headerCellStyle}>Hours Type</th>
                <th style={headerCellStyle}>Start Time</th>
                <th style={headerCellStyle}>Cust. Initial</th>
                <th style={headerCellStyle}>Stop Time</th>
                <th style={headerCellStyle}>Cust. Initial</th>
                <th style={headerCellStyle}>Hourly Rate</th>
                <th style={headerCellStyle}>Discount Time</th>
                <th style={headerCellStyle}>Date</th>
              </tr>
            </thead>
            <tbody>
              {jobTimes.map((jobTime, idx) => {
                const dateVal = jobTime.Date || jobTime.date || jobTime.ForDate || jobTime.for_date || "";
                const rateVal = jobTime.HourlyRate !== undefined && jobTime.HourlyRate !== null ? String(jobTime.HourlyRate) : "";
                const isMoving = jobTime.HoursType !== "Packing";

                return (
                  <tr key={idx}>
                    <td style={bodyCellStyle}>{jobTime.HoursType}</td>

                    <td style={bodyCellStyle}>
                      <input style={inputStyle} className='form-control form-control-sm' defaultValue={jobTime.Start || ""} disabled />
                    </td>

                    <td style={bodyCellStyle}>
                      <div className='d-flex flex-column align-items-center'>
                        {jobTime.PictureStart && (
                          <img src={jobTime.PictureStart} alt='Customer Initial Start' height='30' className='mb-1' />
                        )}
                        {jobTime.PicStartUpdateAt && (
                          <span className='text-muted' style={{ fontSize: "10px", lineHeight: "1.2" }}>{jobTime.PicStartUpdateAt}</span>
                        )}
                      </div>
                    </td>

                    <td style={bodyCellStyle}>
                      <input style={inputStyle} className='form-control form-control-sm' defaultValue={jobTime.End || ""} disabled />
                    </td>

                    <td style={bodyCellStyle}>
                      <div className='d-flex flex-column align-items-center'>
                        {jobTime.PictureEnd && (
                          <img src={jobTime.PictureEnd} alt='Customer Initial End' height='30' className='mb-1' />
                        )}
                        {jobTime.PicEndUpdateAt && (
                          <span className='text-muted' style={{ fontSize: "10px", lineHeight: "1.2" }}>{jobTime.PicEndUpdateAt}</span>
                        )}
            </div>
                    </td>

                    <td style={bodyCellStyle}>
                      <input
                        style={inputStyle}
                        className='form-control form-control-sm'
                        defaultValue={isMoving ? rateVal : "N/A"}
                        disabled
                      />
                    </td>

                     <td style={bodyCellStyle}>
                      <input style={dateInputStyle} className='form-control form-control-sm' defaultValue={jobTime.DiscountTime} disabled />
                    </td>

                    <td style={bodyCellStyle}>
                      <input style={dateInputStyle} className='form-control form-control-sm' defaultValue={String(dateVal)} disabled />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
                            </div>
                        </div>
                    </div>
  );
};
